module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/pool-table-icon-6a1f2eda7f0fcc33438f251f5b165b99.png";